import { EN_MESSAGES } from './catalogs/en';
import { DEFAULT_LOCALE, type Locale, type MessagesCatalog } from './messages';

const MESSAGE_CACHE: Partial<Record<Locale, MessagesCatalog>> = {
  en: EN_MESSAGES,
};

const LOADERS: Record<Locale, () => Promise<MessagesCatalog>> = {
  en: async () => EN_MESSAGES,
  es: async () => (await import('./catalogs/es')).ES_MESSAGES,
  fr: async () => (await import('./catalogs/fr')).FR_MESSAGES,
  ar: async () => (await import('./catalogs/ar')).AR_MESSAGES,
  'zh-Hans': async () => (await import('./catalogs/zhHans')).ZH_HANS_MESSAGES,
  de: async () => (await import('./catalogs/de')).DE_MESSAGES,
  pt: async () => (await import('./catalogs/pt')).PT_MESSAGES,
};

export function primeMessages(locale: Locale, messages: MessagesCatalog) {
  MESSAGE_CACHE[locale] = messages;
}

export function getLoadedMessages(locale: Locale): MessagesCatalog {
  return MESSAGE_CACHE[locale] ?? EN_MESSAGES;
}

export async function loadMessages(locale: Locale): Promise<MessagesCatalog> {
  if (MESSAGE_CACHE[locale]) return MESSAGE_CACHE[locale]!;
  if (locale === DEFAULT_LOCALE) return EN_MESSAGES;

  const messages = await LOADERS[locale]();
  MESSAGE_CACHE[locale] = messages;
  return messages;
}
